var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6333 5.63406L12.1706 4.90408L9.72864 0.352135C9.66194 0.227506 9.55222 0.126615 9.41667 0.0652895C9.07673 -0.0890138 8.66364 0.0395723 8.49368 0.352135L6.05172 4.90408L0.589048 5.63406C0.438443 5.65384 0.300747 5.71912 0.195323 5.81803C0.0678715 5.93848 -0.00236 6.10053 6.05561e-05 6.26856C0.00248112 6.4366 0.0773557 6.59688 0.208232 6.71418L4.16055 10.2572L3.22679 15.2602C3.2049 15.3766 3.2189 15.4963 3.26722 15.6057C3.31555 15.7151 3.39625 15.8099 3.50018 15.8793C3.60411 15.9488 3.72712 15.99 3.85525 15.9984C3.98337 16.0068 4.1115 15.982 4.22509 15.9269L9.11116 13.5648L13.9972 15.9269C14.1306 15.9922 14.2855 16.0139 14.434 15.9902C14.8083 15.9308 15.0601 15.6044 14.9955 15.2602L14.0618 10.2572L18.0141 6.71418C18.1217 6.61724 18.1927 6.49064 18.2142 6.35216C18.2723 6.00597 18.0098 5.68549 17.6333 5.63406Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.adb81cfe.svg";
export { ForwardRef as ReactComponent };